import { render } from "./CardEmbarkationSkeleton.vue?vue&type=template&id=f24c25ba&scoped=true"
const script = {}

import "./CardEmbarkationSkeleton.vue?vue&type=style&index=0&id=f24c25ba&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24c25ba"]])

export default __exports__